import clsx from 'clsx';
import React from 'react';
import styles from './Label.module.scss';

interface LabelProps {
    required?: boolean;
    className?: string;
    children?: React.ReactNode;
}

export const Label: React.FC<LabelProps> = ({ required, className, children }) => {
    return (
        <label className={clsx(styles.root, className)}>
            {children}
            {required && <span className={styles.asterisk}>*</span>}
        </label>
    );
};
